<script>
    export let player_image;
    export let player_positions;
    export let player_name;
    export let player_inj_tag = "H";
    export let detail_string = "";
</script>
<style>
    .shop-pill {
        display: inline-block;
        font-size: .65rem;
        line-height: 1.2;
        padding: .1rem .4rem;
        border-radius: 1rem;
        border: 1px solid #b6d4fe;
        background: #eaf2ff;
        color: #0a58ca;
        vertical-align: middle;
        white-space: nowrap;
        opacity: .85;
    }
    :global(tr:hover) .shop-pill { opacity: 1; background: #0d6efd; color: #fff; border-color: #0d6efd; }
</style>
<div class="d-flex">
    <img class="d-none d-sm-block mt-auto" style="object-fit: contain;" alt="{player_name}" loading="lazy" height="65" width="89" src="{player_image}" onerror="this.src='https://dfstud.nyc3.digitaloceanspaces.com/dfstud/static/fantasy/img/brand/horse_default_profile2.png';">
    <span class="d-block d-sm-none text-primary fw-normal">{player_name}</span>
    <div class="lead d-flex flex-column">
        <span class="d-none d-sm-block"><span class="px-1 border bg-light">{player_positions}</span> <span class="text-primary fw-normal">{player_name}</span> <span class="shop-pill" title="Compare every sportsbook's line for this player">🛒 Shop lines</span></span>
        <span class="d-none d-sm-block">{@html detail_string}
            {#if player_inj_tag == "O"}
            <span class="badge bg-danger">OUT</span>
            {:else if player_inj_tag == "Q" || player_inj_tag == "D" || player_inj_tag == "GTD"}
            <span class="badge bg-warning">{player_inj_tag}</span>
            {/if}
        </span>
    </div>
</div>